var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.258,
    height: 28.582,
    viewBox: "0 0 28.258 28.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.146,
    y1: 0.146,
    x2: 0.854,
    y2: 0.854,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fcb720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff1c74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c1cd1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Instagram",
    "data-name": "03.Instagram",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 28.258,
    height: 28.257,
    rx: 14.129,
    transform: "translate(0.001 0.325)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139977",
    "data-name": "Group 139977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shade",
    d: "M25.06,4.889a50.952,50.952,0,0,1-8.712,11.452A51.02,51.02,0,0,1,4.9,25.047q-.359-.312-.7-.651A14.29,14.29,0,1,1,24.411,4.184q.336.341.649.7Z",
    transform: "translate(-0.016 0)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.767 6.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34240",
    "data-name": "Path 34240",
    d: "M46.906,36h-6.77A4.137,4.137,0,0,0,36,40.137v6.77a4.137,4.137,0,0,0,4.137,4.137h6.77a4.137,4.137,0,0,0,4.137-4.137v-6.77A4.137,4.137,0,0,0,46.906,36Zm2.821,10.312a3.415,3.415,0,0,1-3.415,3.415H40.731a3.415,3.415,0,0,1-3.415-3.415V40.731a3.415,3.415,0,0,1,3.415-3.415h5.581a3.415,3.415,0,0,1,3.415,3.415Z",
    transform: "translate(-36 -36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34241",
    "data-name": "Path 34241",
    d: "M62.2,56.5l-.036-.036-.03-.03a3.791,3.791,0,0,0-2.678-1.106,3.859,3.859,0,0,0-3.832,3.887,3.9,3.9,0,0,0,1.128,2.747,3.8,3.8,0,0,0,2.712,1.128A3.9,3.9,0,0,0,62.2,56.5Zm-2.744,5.265a2.55,2.55,0,1,1,2.514-2.55A2.55,2.55,0,0,1,59.452,61.767Z",
    transform: "translate(-51.93 -51.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34242",
    "data-name": "Path 34242",
    d: "M94.563,50.4a.918.918,0,0,1-.912.925.9.9,0,0,1-.643-.269.927.927,0,0,1,.645-1.578.907.907,0,0,1,.581.211l.019.019a.574.574,0,0,1,.083.083l.021.023A.925.925,0,0,1,94.563,50.4Z",
    transform: "translate(-82.071 -46.945)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.bf2f577a96a3d1f4a235b33584ace628.svg";
export { ForwardRef as ReactComponent };